import { render } from "./ImgLoading.vue?vue&type=template&id=dd115226&ts=true"
import script from "./ImgLoading.vue?vue&type=script&lang=ts"
export * from "./ImgLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__